<template>
    <div class="container">
        <donation-form :campaigns="campaigns" :campaign_id="campaign_id" :recurring="recurring" :debit="debit" v-on:formSubmittedSuccessfully="formSubmittedSuccessfully" v-if="showForm"></donation-form>
<!--        <paypal-button v-if="paypal" :donation="donation"/>-->
        <paygate-button v-if="paygate" :paygateResponse="paygateResponse" />
    </div>
</template>

<script>
    import DonationForm from "./DonationForm";
    import Loader from "../Loader";
    import PayfastButton from "./PayfastButton";
    import PaypalButton from "./PaypalButton";
    import PaygateButton from "./PaygateButton";

    export default {
      name: "DonationPage",
      props: {
        campaigns: {
          type: Array,
          default: ''
        },
        recurring: {
          type: Boolean,
          default: false
        },
        debit: {
          type: Boolean,
          default: false
        },
        campaign_id: {
          type: Number,
          default: 1
        },
      },
      components: {
        DonationForm,
        Loader,
        PayfastButton,
        PaypalButton,
        PaygateButton
      },
      data: () => ({
        loading: false,
        payfastButtonResponse: undefined,
        showForm: true,
        paygate: false,
        paygateResponse: undefined
      }),
      methods: {
        formSubmittedSuccessfully(data) {
          this.paygate = true;
          this.paygateResponse = data;
        }
      },
      mounted() {
        this.$on('my-event', function() {
          console.log('bob');
        })
      }
    }
</script>

<style scoped>

</style>
